import { Expand } from './lib';

function install(Vue, { name = Expand.name } = {}) {
  Vue.component(name, Expand);
}

export default { install };
export * from './lib';
